<template>
  <div class="outer">
    <div class="inner" @click="toggle()" :class="{ opened: open }">
      <div class="control" @click.self.stop="sub">&minus;</div>
      <div>{{ content }}</div>
      <div class="control" @click.self.stop="add">&plus;</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "counterWidget",
  computed: {
    content() {
      if (this.count > 0 || this.open) return "" + this.count;
      return "+";
    },
    open() {
      return this.count >= 1;
    }
  },
  beforeDestroy() {
    this.bus.$off("added", this.changed);
  },
  created() {
    this.count = this.ingredient.count;
    this.bus.$on("added", this.changed);
  },
  data() {
    return {
      count: 0
    };
  },
  methods: {
    toggle() {
      if (this.open && this.count === 0) {
        this.add();
      }
      if (this.bus && this.open) {
        this.bus.$emit("opened", this.ingredient.id);
      }
    },
    add() {
      if (
        this.count + 1 > this.ingredient.max_count &&
        this.ingredient.max_count !== -1
      )
        return;
      this.$emit("change", {
        ingredient: this.ingredient,
        count: this.count + 1
      });
    },
    sub() {
      if (this.count - 1 < Math.max(this.ingredient.min_count, 0)) return;
      this.$emit("change", {
        ingredient: this.ingredient,
        count: this.count - 1
      });
    },
    changed({ id, group_id, count }) {
      if (id === this.ingredient.id && group_id === this.group.id) {
        this.count = count;
      }
    }
  },
  props: {
    ingredient: Object,
    group: Object,
    bus: Object
  }
};
</script>

<style scoped>
.inner {
  display: flex;
  transition: all 500ms ease;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background-color: var(--component_counterWidget_inner_background-color);
  color: var(--component_counterWidget_inner_color);
  font-size: var(--component_counterWidget_inner_font-size);
  font-family: var(--component_counterWidget_inner_font-family);
  align-items: center;
  justify-content: space-between;
}
.control {
  transition: all 200ms ease;
  transition-delay: 150ms;
  width: 0;
  opacity: 0;
  overflow: hidden;
}

.opened .control {
  width: 20px;
  opacity: 1;
}

.inner.opened {
  width: 120px;
  padding-left: 8px;
  padding-right: 8px;
  background-color: var(
    --component_counterWidget_inner_opened_background-color
  );
}

.outer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 120px;
}
</style>
